// extracted by mini-css-extract-plugin
export default {"show_icon":"DeleteSchoolMode_show_icon__Tpoxx"};